export default __webpack_public_path__ + "static/media/hand-splash-tablet.c65bc9d1.png";